

export default {
  SET_KATEGORI_LIST(state, payload){
    state.kategoriList = payload
  },
  SET_TOTAL(state, payload){
    state.totalRecords = payload
}
}
